function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.loading-search-1{fill:#26FF9D;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.loading-search-2{fill:none;}\n  #loading-search-check{opacity: 0}\n");
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "loading-search-1",
  cx: 26.2,
  cy: 26.2,
  r: 24.8,
  transform: "rotate(-180 26.25 26.25)"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Large-DesktopFormValid"
}, /*#__PURE__*/React.createElement("g", {
  id: "loading-search-check",
  transform: "translate(3 5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M33.8,12.2L18.3,27.7l-5.5-5.5c-0.3-0.3-0.7-0.3-0.9,0l-0.6,0.6c-0.3,0.3-0.3,0.7,0,0.9l6.6,6.5 c0.3,0.3,0.7,0.3,0.9,0l16.6-16.5c0.3-0.3,0.3-0.7,0-0.9l-0.6-0.6C34.4,12,34,12,33.8,12.2z"
})));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group-Copy"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle",
  className: "loading-search-2",
  d: "M8.2,9h35.1v35.1H8.2V9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "loading-search-glass",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M35.4,34.8l-6.4-6.4c-0.1-0.1-0.3-0.2-0.4-0.2H28c1.7-1.9,2.8-4.3,2.8-7c0-5.7-4.6-10.4-10.4-10.4 c-5.7,0-10.4,4.6-10.4,10.4c0,5.7,4.6,10.4,10.4,10.4c2.7,0,5.2-1,7-2.8v0.5c0,0.2,0.1,0.3,0.2,0.4l6.4,6.4c0.2,0.2,0.6,0.2,0.8,0 l0.5-0.5C35.6,35.4,35.6,35,35.4,34.8z M20.4,29.9c-4.9,0-8.8-3.9-8.8-8.8c0-4.9,3.9-8.8,8.8-8.8c4.9,0,8.8,3.9,8.8,8.8 C29.1,26,25.2,29.9,20.4,29.9z"
})));
var SvgLoadingSearchIcon = function SvgLoadingSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53 53",
    style: {
      enableBackground: "new 0 0 53 53"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoadingSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading-search-icon.71db6c0f.svg";
export { ForwardRef as ReactComponent };